module.exports = __webpack_public_path__ + "img/DW365-087.ac0104ca.jpg";